import * as React from 'react';
import arrayMutators from 'final-form-arrays';
import { useDispatch } from 'react-redux';
import { Form } from '@gandi/form/FinalForm';
import { useTranslator } from '@gandi/translate';
import { Spinner } from '@gandi/ui';
import { clearSubmitError } from '../formUtils/mutators';
import { SectionReadOnlyProvider } from '../formUtils/readOnly';
import { useValidate } from '../formUtils/useValidate';
import { useMapFormDataToTemplate, useCreationInitialFormData } from '../hooks';
import { mapFetchErrorToFormError } from '../models/mapError';
import actions from '../modules/actions';
import { templateResource } from '../modules/templateResource';
import { jsx as _jsx } from "react/jsx-runtime";
const noop = initialData => initialData;
export default function CreateForm({
  transformInitialValues = noop,
  doSubmit,
  children,
  onSubmitFail,
  onSubmitSuccess,
  ...rest
}) {
  const dispatch = useDispatch();
  const {
    __
  } = useTranslator();
  const validate = useValidate();
  // Use the hook so we have default sharingId & orgname set to user's pesronal orga
  const initialFormData = useCreationInitialFormData();
  // Using the hook we can map the sharingId to the orgname
  const mapFormDataToTemplate = useMapFormDataToTemplate();
  const [initialValues, setInitialValues] = React.useState();
  React.useEffect(() => {
    // $FlowFixMe[unused-promise]
    Promise.resolve(transformInitialValues(initialFormData)).then(values => setInitialValues(values));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const onSubmit = async formValues => {
    try {
      const {
        data
      } = await dispatch(
      // $FlowFixMe[incompatible-call] cf. mapFormDataToTemplate
      actions.createOneWithSharingId(mapFormDataToTemplate(formValues), {
        query: {
          sharing_id: formValues.sharingId
        }
      }));
      if (doSubmit) await doSubmit({
        template: data,
        formValues
      });
      dispatch(templateResource.invalidate());
      if (onSubmitSuccess) {
        onSubmitSuccess({
          formValues,
          template: data
        });
      }
      return undefined;
    } catch (err) {
      const errors = mapFetchErrorToFormError(err);
      if (onSubmitFail) {
        onSubmitFail(errors);
      }
      return errors;
    }
  };
  if (!initialValues) {
    return /*#__PURE__*/_jsx(Spinner, {
      centered: true,
      children: __('Template editor is loading')
    });
  }
  return /*#__PURE__*/_jsx(SectionReadOnlyProvider, {
    children: /*#__PURE__*/_jsx(Form, {
      initialValues: initialValues
      // this className is required in order have correct rendering of
      // `gandi/form`'s «control» components (input or label …)
      ,
      className: "form-stacked",
      onSubmit: onSubmit,
      validate: validate,
      mutators: {
        ...arrayMutators,
        clearSubmitError
      },
      ...rest,
      children: children
    })
  });
}